export default "dist/images/block-divider-basic.dba5538.png";